import React, { useEffect } from 'react';

import { BrowserRouter as Router } from 'react-router-dom';

import { initializeGoogleAnalytics } from 'services/google-analytics';

import AppProvider from './hooks';
import Routes from './routes';
import GlobalStyle from './styles/global';

const App: React.FC = () => {
  useEffect(() => {
    initializeGoogleAnalytics();
  }, []);

  return (
    <div>
      <Router>
        <AppProvider>
          <Routes />
        </AppProvider>
        <GlobalStyle />
      </Router>
    </div>
  );
};

export default App;
